import React from 'react';
import { HiOutlineFlag } from 'react-icons/hi2'; // Icon

const steps = ['Projet', 'Profil', 'Financement', 'Résultat', 'Visite Virtuelle'];

const StepProgress = ({ currentStep }) => {
  return (
    <div className="w-64 p-6">
      {/* Final capsule header: centered + larger text */}
      <div className="flex items-center justify-center gap-2 mb-6 px-4 py-2 rounded-full bg-blue-600 shadow-sm">
        <HiOutlineFlag className="w-5 h-5 text-white" />
        <span className="text-sm font-semibold text-white whitespace-nowrap">
          Parcours (5 étapes)
        </span>
      </div>

      {/* Step list */}
      <ul className="space-y-4 text-sm">
        {steps.map((label, idx) => {
          const isActive = idx === currentStep;

          return (
            <li
              key={label}
              className={`flex items-center gap-3 ${
                isActive ? 'text-blue-600 font-semibold' : 'text-gray-700'
              }`}
            >
              <span
                className={`w-6 h-6 rounded-full text-xs font-medium flex items-center justify-center border transition-all duration-200 ${
                  isActive
                    ? 'bg-blue-600 text-white border-blue-600 shadow-sm'
                    : 'bg-white text-gray-500 border-gray-300'
                }`}
              >
                {idx + 1}
              </span>
              {label}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default StepProgress;
